var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCard = function SvgCard(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14.625C0.5 15.3212 0.776562 15.9889 1.26884 16.4812C1.76113 16.9734 2.42881 17.25 3.125 17.25H18.875C19.5712 17.25 20.2389 16.9734 20.7312 16.4812C21.2234 15.9889 21.5 15.3212 21.5 14.625V7.40625H0.5V14.625ZM3.59375 11.0625C3.59375 10.6895 3.74191 10.3319 4.00563 10.0681C4.26935 9.80441 4.62704 9.65625 5 9.65625H7.25C7.62296 9.65625 7.98065 9.80441 8.24437 10.0681C8.50809 10.3319 8.65625 10.6895 8.65625 11.0625V12C8.65625 12.373 8.50809 12.7306 8.24437 12.9944C7.98065 13.2581 7.62296 13.4062 7.25 13.4062H5C4.62704 13.4062 4.26935 13.2581 4.00563 12.9944C3.74191 12.7306 3.59375 12.373 3.59375 12V11.0625ZM18.875 0.75H3.125C2.42881 0.75 1.76113 1.02656 1.26884 1.51884C0.776562 2.01113 0.5 2.67881 0.5 3.375V4.59375H21.5V3.375C21.5 2.67881 21.2234 2.01113 20.7312 1.51884C20.2389 1.02656 19.5712 0.75 18.875 0.75Z",
    fill: "#5ECC4D"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card.e0d93484510147111a6111bd9ca58d2c.svg";